import Scrollspy from 'react-scrollspy';

const NavSpy = ({ change }) => {
  const sections = [
    { name: 'Home' },
    { name: 'About' },
    { name: 'Services' },
    { name: 'Portfolio' },
    { name: 'Team' },
    { name: 'Contact' },
  ];

  const navScroll = (id, index) => {
    const element = document.getElementById(id);

    if (!element) return;

    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });

    setTimeout(() => {
      if (change) {
        change(index);
      }
    }, 300);
  };

  return (
    <div className='right-nav'>
      <Scrollspy
        items={sections.map((section) => section.name.toLowerCase())}
        currentClassName='active'
      >
        {sections.map((section, index) => (
          <li key={section.name}>
            <span onClick={() => navScroll(section.name.toLowerCase(), index)}>
              {section.name}
            </span>
          </li>
        ))}
      </Scrollspy>
    </div>
  );
};

export default NavSpy;
